/* The Glowcery · section behaviour (formula finder, gallery, product form, quick add) */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    if (/amount_with_comma_separator/.test(fmt)) value = value.replace('.', ',');
    if (/amount_no_decimals/.test(fmt)) value = String(Math.round(cents / 100));
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  };

  var cartIsModal = function () {
    var s = window.theme && window.theme.settings;
    return !!(s && (s.cartType === 'modal' || s.cart_type === 'modal') && window.Alpine);
  };

  /* Add items to the basket, refresh the theme's cart drawer and open it */
  var addToCart = function (items, button, errorEl) {
    if (button) { button.setAttribute('aria-disabled', 'true'); button.dataset.label = button.dataset.label || button.textContent; button.textContent = button.dataset.adding || 'Adding…'; }
    if (errorEl) errorEl.textContent = '';
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || 'Something went wrong. Please try again.');
        if (cartIsModal()) {
          document.dispatchEvent(new CustomEvent('theme:update:cart'));
          try {
            var modals = window.Alpine.store('modals');
            modals.closeAll && modals.closeAll();
            modals.open('cart');
          } catch (err) {
            document.dispatchEvent(new CustomEvent('theme:open:cart-drawer'));
          }
        } else {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }
      })
      .catch(function (e) { if (errorEl) errorEl.textContent = e.message; })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.textContent = button.dataset.label; }
      });
  };

  /* Formula finder */
  var initFormula = function (root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    var select = function (tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (next) { e.preventDefault(); select(next); next.focus(); }
      });
    });
  };

  /* Product gallery */
  var initGallery = function (root) {
    var thumbs = root.querySelectorAll('[data-gl-thumb]');
    var slides = root.querySelectorAll('[data-gl-slide]');
    var show = function (id) {
      slides.forEach(function (s) { s.hidden = s.dataset.glSlide !== String(id); });
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(t.dataset.glThumb === String(id))); });
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.glThumb); }); });
    root.addEventListener('gl:media', function (e) { if (e.detail && root.querySelector('[data-gl-slide="' + e.detail + '"]')) show(e.detail); });
  };

  /* Product form: variants, selling plans, quantity, add to basket */
  var initProductForm = function (form) {
    var dataEl = form.querySelector('script[data-gl-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var errorEl = form.querySelector('[data-gl-error]');
    var submit = form.querySelector('[type="submit"]');
    var priceEls = document.querySelectorAll('[data-gl-price="' + form.dataset.section + '"]');
    var stickyBtn = document.querySelector('[data-gl-sticky="' + form.dataset.section + '"]');
    var gallery = document.querySelector('[data-gl-gallery="' + form.dataset.section + '"]');
    var rechargeEl = form.querySelector('[data-gl-recharge]');

    var currentVariant = function () {
      if (variants.length <= 1) return variants[0];
      var chosen = Array.prototype.map.call(form.querySelectorAll('[data-gl-option]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
    };

    /* The chosen selling plan: works with the theme's own radios and with the
       Recharge widget (which may use radios, a select or a hidden input). */
    var sellingPlanId = function () {
      var els = form.querySelectorAll('[name="selling_plan"]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.disabled) continue;
        if (el.type === 'radio' || el.type === 'checkbox') {
          if (el.checked && el.value) return el.value;
        } else if (el.value) {
          return el.value;
        }
      }
      return '';
    };

    var planPrice = function (variant) {
      var planId = sellingPlanId();
      if (!variant || !planId) return variant ? variant.price : 0;
      var alloc = (variant.selling_plan_allocations || []).find(function (a) { return String(a.selling_plan_id) === planId; });
      return alloc ? alloc.price : variant.price;
    };

    var update = function () {
      var v = currentVariant();
      var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
      if (!v) {
        submit.disabled = true; submit.textContent = submit.dataset.unavailable;
        return;
      }
      idInput.value = v.id;
      var unit = planPrice(v);
      priceEls.forEach(function (el) { el.textContent = money(unit); });
      var label = v.available ? submit.dataset.addLabel + ' · ' + money(unit * q) : submit.dataset.soldOut;
      submit.disabled = !v.available;
      submit.textContent = label;
      submit.dataset.label = label;
      if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = !v.available; }
      form.querySelectorAll('[data-gl-plan-price]').forEach(function (el) {
        var id = el.dataset.glPlanPrice;
        var alloc = (v.selling_plan_allocations || []).find(function (a) { return String(a.selling_plan_id) === id; });
        el.textContent = money(alloc ? alloc.price : v.price);
      });
      form.querySelectorAll('[data-gl-once-price]').forEach(function (el) { el.textContent = money(v.price); });
      if (variants.length > 1 && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (gallery && v.featured_media) gallery.dispatchEvent(new CustomEvent('gl:media', { detail: String(v.featured_media.id) }));
    };

    /* Recharge can change its value after the change event fires, so update on the next tick */
    var deferredUpdate = function () { setTimeout(update, 0); };

    form.addEventListener('change', deferredUpdate);
    form.querySelectorAll('[data-gl-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.glStep, 10));
        qty.value = n; update();
      });
    });
    if (qty) qty.addEventListener('input', update);

    if (rechargeEl) {
      rechargeEl.addEventListener('click', function () { setTimeout(update, 50); });
      if (window.MutationObserver) {
        new MutationObserver(deferredUpdate).observe(rechargeEl, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked'] });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var item = { id: Number(idInput.value), quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1) };
      var planId = sellingPlanId();
      if (planId) item.selling_plan = Number(planId);
      addToCart([item], submit, errorEl);
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : submit.click(); });
    update();
  };

  /* Any button that adds a fixed set of items, e.g. "Add the ritual" */
  var initQuickAdd = function (btn) {
    btn.addEventListener('click', function () {
      var items = JSON.parse(btn.dataset.glAdd || '[]');
      if (!items.length) return;
      var err = btn.parentElement.querySelector('[data-gl-error]');
      addToCart(items, btn, err);
    });
  };

  var init = function (scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-gl-formula]').forEach(initFormula);
    scope.querySelectorAll('[data-gl-gallery]').forEach(initGallery);
    scope.querySelectorAll('form[data-gl-product-form]').forEach(initProductForm);
    scope.querySelectorAll('[data-gl-add]').forEach(initQuickAdd);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Re-initialise sections when edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
